var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopySmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-small"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signifier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33299 1.33301H13.333C13.6866 1.33301 14.0258 1.47348 14.2758 1.72353C14.5259 1.97358 14.6663 2.31272 14.6663 2.66634V10.6663C14.6663 11.02 14.5259 11.3591 14.2758 11.6091C14.0258 11.8592 13.6866 11.9997 13.333 11.9997H5.33299C4.97937 11.9997 4.64023 11.8592 4.39018 11.6091C4.14013 11.3591 3.99966 11.02 3.99966 10.6663V2.66634C3.99966 2.31272 4.14013 1.97358 4.39018 1.72353C4.64023 1.47348 4.97937 1.33301 5.33299 1.33301ZM5.33299 10.6663H13.333V2.66634H5.33299V10.6663Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 4.66634C2.66634 4.29815 2.36786 3.99967 1.99967 3.99967C1.63148 3.99967 1.33301 4.29815 1.33301 4.66634V13.333C1.33301 14.0694 1.92996 14.6663 2.66634 14.6663H11.333C11.7012 14.6663 11.9997 14.3679 11.9997 13.9997C11.9997 13.6315 11.7012 13.333 11.333 13.333H2.66634V4.66634Z",
    fill: "#979797"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySmall);
export default __webpack_public_path__ + "static/media/copy-small.33b9a250186107558a233ec73b9fb35c.svg";
export { ForwardRef as ReactComponent };